export const isRouteBlock = () => {

    const value = localStorage.getItem('blockChangeRoute');

    if (value === 'true') {
        return true;
    }

    return false;
};

export const blockRoute = () => {
    localStorage.setItem('blockChangeRoute', true)
};

export const unblockRoute = () => {
    localStorage.setItem('blockChangeRoute', false)
};